export default "__VITE_ASSET__DUoUuW3v__"